import { useState } from "react";

/**
 * A short piece of page state kept in this browser, for the search and toggles a table does not
 * own, so they are still there on coming back from a record. Blocked storage just forgets.
 */
export function useRememberedText<T extends string>(
  key: string,
  initial: T,
  accept: (value: string) => value is T = (value): value is T => true,
): [T, (next: T) => void] {
  const [value, setValue] = useState<T>(() => {
    try {
      const stored = globalThis.localStorage?.getItem(key);
      return stored !== null && stored !== undefined && accept(stored) ? stored : initial;
    } catch {
      return initial;
    }
  });
  const set = (next: T) => {
    setValue(next);
    try {
      globalThis.localStorage?.setItem(key, next);
    } catch {
      // The page keeps working; it just won't remember.
    }
  };
  return [value, set];
}
